<template>
    <b-container>
        <b-row class="mb-4">
            <b-col>
                <div class="d-flex justify-content-between align-items-center">
                    <div>
                        <!-- Migration Button -->
                        <b-button
                            variant="outline-primary"
                            @click="runMigration"
                            :disabled="migrating"
                            v-b-tooltip.hover
                            title="Import existing files from upload folder into media management system">
                            <b-spinner small v-if="migrating"></b-spinner>
                            <i v-else class="fal fa-sync"></i>
                            {{ migrating ? 'Migrating...' : 'Import Files' }}
                        </b-button>
                    </div>
                </div>
            </b-col>
        </b-row>

                    <!-- Media Gallery -->
        <media-gallery
            :enable-actions="true"
            :image-only="false"
            ref="mediaGallery">
        </media-gallery>
    </b-container>
</template>

<script>
    import MediaGallery from '../components/MediaGallery.vue';
    import FileApi from '@shared/_api/file';

    export default {
        name: 'MediaLibrary',
        components: {
            MediaGallery
        },
        data() {
            return {
                migrating: false,
                migrationStats: null
            };
        },
        mounted() {
            // Load last migration stats from localStorage
            const stats = localStorage.getItem('media_migration_stats');
            if (stats) {
                try {
                    this.migrationStats = JSON.parse(stats);
                } catch (e) {
                    console.error('Failed to parse migration stats', e);
                }
            }
        },
        methods: {
            runMigration() {
                this.$bvModal.msgBoxConfirm(
                    'This will scan the upload folder and import all files that are not yet in the media library. Files already imported will be skipped. Continue?',
                    {
                        title: 'Import Files',
                        okTitle: 'Import',
                        cancelTitle: 'Cancel',
                        okVariant: 'primary'
                    }
                ).then(confirmed => {
                    if (!confirmed) return;

                    this.migrating = true;
                    FileApi.migrateExistingFiles()
                        .then(response => {
                            const stats = {
                                migratedCount: response.migratedCount,
                                timestamp: new Date().toISOString()
                            };

                            this.migrationStats = stats;
                            localStorage.setItem('media_migration_stats', JSON.stringify(stats));

                            this.$bvToast.toast(
                                `Successfully imported ${response.migratedCount} files to the media library.`,
                                {
                                    title: 'Migration Complete',
                                    variant: 'success',
                                    autoHideDelay: 5000,
                                    solid: true
                                }
                            );

                            // Refresh the gallery
                            if (this.$refs.mediaGallery) {
                                this.$refs.mediaGallery.loadMedia();
                            }
                        })
                        .catch(error => {
                            console.error('Migration error:', error);
                            this.$bvToast.toast(
                                'Failed to import files. Please check that the backend is running and the database table exists.',
                                {
                                    title: 'Migration Failed',
                                    variant: 'danger',
                                    autoHideDelay: 7000,
                                    solid: true
                                }
                            );
                        })
                        .finally(() => {
                            this.migrating = false;
                        });
                });
            }
        }
    };
</script>

<style lang="scss" scoped>
    h2 {
        font-weight: 600;
    }
</style>